import React from "react";
import qr from "assets/images/imgs/onelink_qr.png";
import "./QRPromoCard.scss";

const QRPromoCard = () => {
    return (
        <div className="qr-promo-card" aria-label="캠핏 앱 다운로드 QR 코드">
            <img
                src={qr}
                alt="버클 앱 다운로드 QR 코드"
                className="qr-promo-card__qr"
            />
            <p className="qr-promo-card__title">
                버클 앱 설치하시면 투어 오픈 소식,<br />
                예약 알림등을 빠르게 받아볼 수 있어요!
            </p>
            <p className="qr-promo-card__sub">
                QR 코드를 스캔하면<br />
                다운로드로 연결됩니다
            </p>
        </div>
    );
};

export default QRPromoCard;
